import styled, { css } from 'styled-components';
import { SYS_BORDER_RADIUS_SM } from '@oneaudi/unified-web-common';
import { ComponentContainer, ComponentsContainer, Row } from './NumbersMode.style';
import { Alignment, TextComponentContainerProps } from '../../types';

export const TextRow = styled(Row)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    &:not(:last-child) {
      margin-block-end: 1px;
    }
  }
`;

export const TextComponentsContainer = styled(ComponentsContainer)`
  /* Apply rounded corners only to corner elements */
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    /* Top-left corner: first row, first child */
    ${Row}:first-child ${ComponentContainer}:first-child {
      border-top-left-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Top-right corner: first row, last child */
    ${Row}:first-child ${ComponentContainer}:last-child {
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Bottom-left corner: last row, first child */
    ${Row}:last-child ${ComponentContainer}:first-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Bottom-right corner: last row, last child */
    ${Row}:last-child ${ComponentContainer}:last-child {
      border-bottom-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    /* Mobile: first element gets top corners */
    ${Row}:first-child ${ComponentContainer}:first-child {
      border-top-left-radius: ${SYS_BORDER_RADIUS_SM};
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Mobile: last element gets bottom corners */
    ${Row}:last-child ${ComponentContainer}:last-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
      border-bottom-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
  }
`;

export const TextComponentContainer = styled(ComponentContainer)<TextComponentContainerProps>`
  flex-grow: 1;
  ${({ textAlignment }) =>
    textAlignment === Alignment.CENTER
      ? css`
          align-items: center;
          text-align: center;
        `
      : css`
          align-items: flex-start;
          text-align: left;
        `};
`;
